
import {Component, Vue} from 'vue-property-decorator';
import NavigationBarComponent from '@/components/Misc/NavigationBar.component.vue';

@Component({
  components: {NavigationBarComponent},
})
export default class App extends Vue {}
